/**
 * Andre Garen - Tam ekran arama katmani.
 * Shopify predictive search JSON API'si (`/search/suggest.json`) kullanilir;
 * sayfa yenilenmez. Enter tam sonuc sayfasina gonderir.
 */
(function () {
  'use strict';

  var layer, input, popular, results, empty, allLink, trigger;
  var debounceTimer = null;
  var activeController = null;
  var DEBOUNCE_MS = 250;

  function q(sel, root) { return (root || document).querySelector(sel); }

  /* Denetim (P1 backlog madde 2, canlida dogrulandi): /search/suggest.json
     urun.price'i bicimlenmemis ham deger olarak doner ("15370.00") - sitenin
     geri kalaninin (money_without_trailing_zeros / ag-price.liquid) kullandigi
     nokta-binlik/virgul-ondalik+"₺" bicimiyle ("15.370 ₺") tutarsizdi, arama
     sonuclarinda ciplak "15370.00" gorunuyordu. ag-occasion-filter.js'teki
     fmtMoney() ile ayni yaklasim - burada API zaten cent degil ana birim
     (TRY) dondurdugu icin *100 ile cent'e cevrilip ayni fonksiyona veriliyor. */
  function fmtMoney(raw) {
    var n = parseFloat(raw);
    if (isNaN(n)) return '';
    var cents = Math.round(n * 100);
    var whole = cents % 100 === 0;
    var v = whole ? String(Math.round(cents / 100)) : (cents / 100).toFixed(2).replace('.', ',');
    var parts = v.split(',');
    parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, '.');
    return (parts[1] ? parts.join(',') : parts[0]) + ' ₺';
  }

  function refs() {
    layer = q('[data-ag-search]');
    input = q('[data-ag-search-input]', layer);
    popular = q('[data-ag-search-popular]', layer);
    results = q('[data-ag-search-results]', layer);
    empty = q('[data-ag-search-empty]', layer);
    allLink = q('[data-ag-search-all]', layer);
  }

  function open(fromEl) {
    refs();
    if (!layer) return;
    trigger = fromEl || null;
    layer.hidden = false;
    layer.setAttribute('data-open', '1');
    document.body.style.overflow = 'hidden';
    if (input) {
      input.value = '';
      showPopular();
      setTimeout(function () { input.focus(); }, 10);
    }
  }

  function close() {
    if (!layer) refs();
    if (!layer) return;
    layer.removeAttribute('data-open');
    layer.hidden = true;
    document.body.style.overflow = '';
    if (activeController) { activeController.abort(); activeController = null; }
    if (trigger && trigger.focus) trigger.focus();
  }

  // Tur 7 EK 3: sonuc listesinin altinda "Tum sonuclari gor" (/search?q=...)
  function setAll(term) {
    if (!allLink) return;
    if (term) { allLink.href = '/search?q=' + encodeURIComponent(term) + '&type=product'; allLink.hidden = false; }
    else allLink.hidden = true;
  }

  function showPopular() {
    setAll('');
    if (popular) popular.hidden = false;
    if (results) { results.hidden = true; results.innerHTML = ''; }
    if (empty) empty.hidden = true;
  }

  function showResults(html) {
    if (popular) popular.hidden = true;
    if (empty) empty.hidden = true;
    if (results) { results.hidden = false; results.innerHTML = html; }
  }

  function showEmpty() {
    if (popular) popular.hidden = true;
    if (results) { results.hidden = true; results.innerHTML = ''; }
    if (empty) empty.hidden = false;
  }

  /* Tur 23 EK10 S096: urunun dunyasi etiketinden (gunluk -> day, abiye -> night; ikisi de olabilir) */
  function dunya(p) {
    var t = (p.tags || []).map(function (x) { return String(x).toLocaleLowerCase('tr'); }), d = [];
    if (t.indexOf('günlük') > -1) d.push('day');
    if (t.indexOf('abiye') > -1) d.push('night');
    return d.join(' ');
  }

  function renderProducts(products) {
    return products
      /* Tur 23 EK10 S096: dunya sekmeleri acikken 10 oneri (ag-arama-ek.js) */
      .slice(0, window.agOz && window.agOz('S096') ? 10 : 6)
      .map(function (p) {
        var img = p.image
          ? '<img src="' + p.image + '" alt="" width="60" height="75" loading="lazy">'
          : '<span class="ag-searchlayer__ph" aria-hidden="true"></span>';
        return (
          '<a class="ag-searchlayer__item" href="' + p.url + '" data-dunya="' + dunya(p) + '">' +
          img +
          '<span class="ag-searchlayer__itemtext">' +
          '<span class="ag-searchlayer__itemtitle">' + String(p.title).replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;') + '</span>' +
          '<span class="ag-searchlayer__itemprice">' + fmtMoney(p.price) + '</span>' +
          '</span>' +
          '</a>'
        );
      })
      .join('');
  }

  function search(term) {
    if (activeController) activeController.abort();
    activeController = new AbortController();

    var url = new URL('/search/suggest.json', window.location.origin);
    url.searchParams.set('q', term);
    url.searchParams.set('resources[type]', 'product');
    url.searchParams.set('resources[limit]', window.agOz && window.agOz('S096') ? '10' : '6');
    url.searchParams.set('resources[options][unavailable_products]', 'last');

    fetch(url.toString(), { signal: activeController.signal, headers: { Accept: 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (data) {
        var products = (data.resources && data.resources.results && data.resources.results.products) || [];
        if (products.length === 0) { showEmpty(); setAll(''); }
        else { showResults(renderProducts(products)); setAll(term); }
      })
      .catch(function (err) {
        if (err && err.name === 'AbortError') return;
      });
  }

  document.addEventListener('click', function (e) {
    var t = e.target;
    if (!t.closest) return;

    var opener = t.closest('[data-ag-search-open]');
    if (opener) { e.preventDefault(); open(opener); return; }

    if (t.closest('[data-ag-search-close]')) { e.preventDefault(); close(); return; }
  });

  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape' && layer && layer.getAttribute('data-open') === '1') close();
    if (e.key === 'Tab' && layer && layer.getAttribute('data-open') === '1') { var f = [].filter.call(layer.querySelectorAll('a[href], button:not([disabled]), input:not([disabled]):not([type="hidden"]), select, textarea, [tabindex]:not([tabindex="-1"])'), function (x) { return x.offsetParent !== null; }); if (f.length) { e.preventDefault(); var i = f.indexOf(document.activeElement); f[i < 0 ? 0 : (i + (e.shiftKey ? -1 : 1) + f.length) % f.length].focus(); } }
  });

  document.addEventListener('input', function (e) {
    if (!e.target.closest || !e.target.closest('[data-ag-search-input]')) return;
    var term = e.target.value.trim();
    clearTimeout(debounceTimer);
    if (term.length === 0) { showPopular(); return; }
    debounceTimer = setTimeout(function () { search(term); }, DEBOUNCE_MS);
  });

  // Tur 7 EK 3: Enter artik gercek <form action="/search"> ile gonderiliyor; bos terimle gonderim engellenir.
  document.addEventListener('submit', function (e) {
    var f = e.target.closest && e.target.closest('.ag-searchlayer__form');
    if (!f) return;
    var i = f.querySelector('[data-ag-search-input]');
    if (i && !i.value.trim()) e.preventDefault();
  });

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', refs);
  else refs();

  window.AGSearch = { open: open, close: close };
})();
